var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"welcome-status"}},[_c('h1',[_vm._v("Eternal Monitoring")]),_vm._v(" "),_c('div',{staticClass:"test-container"},[_c('echo-test',{attrs:{"endpoint":"https://api.werksoft.net/eternal/dev/echo/"}}),_vm._v(" "),_c('mock-ephemeral-tests')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-722a833f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WelcomeStatus.vue
// module id = null
// module chunks = 